export default [
  {
    path: '/Performance',
    name: 'HotelsNResorts',
    component: () => import('Components/Performance/content/HotelsNResorts'),
  },
  {
    path: '/Performance/Department-Store',
    name: 'DepartmentStore',
    component: () => import('Components/Performance/content/DepartmentStore'),
  },
  {
    path: '/Performance/perf-etc',
    name: 'perfEtc',
    component: () => import('Components/Performance/content/perfEtc'),
  },
  {
    path: '/Performance/Distribution',
    name: 'Distribution',
    component: () => import('Components/Performance/content/Distribution'),
  },
]
